import { Box, ListItem } from '@rulebooks/evidend-titan';
import { t } from '@lingui/macro';
import { formatUboGround } from 'helpers/ubo';
import type { SummaryCardsComponentProps } from 'helpers/formatMutation';
import React from 'react';
import { ShareholderCapitalCard } from 'summaries/CapitalCards/ShareholderCapitalCard';

export const EndUboSummaryCards = ({
  backgroundVariant = 'white',
  mutation,
}: SummaryCardsComponentProps) => {
  const endUbos = mutation.endUbo || [];

  return (
    <>
      {!!endUbos.length && (
        <Box spaceAfter={10}>
          {endUbos.map((endUbo, index) => (
            <ShareholderCapitalCard
              key={index}
              backgroundVariant={backgroundVariant}
              party={endUbo.naturalPerson}
            >
              <ListItem prefixAdornment="•">{t`Einde UBO (${formatUboGround(endUbo.ground)})`}</ListItem>
            </ShareholderCapitalCard>
          ))}
        </Box>
      )}
    </>
  );
};
